import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function OfferingsSend() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">네이버부동산 매물 등록이 무제한, 원가 결제로 비용 부담까지 줄일 수 있어요<br />(BASIC 이상 멤버쉽 구독 시)</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ol className="list_order"><li><h4 className="order_num">Step 1</h4><Image className="img_guide" src="/image/desktop/popup/offerings01_01.png" alt={"\uAC80\uC99D\uBC29\uC2DD \uC120\uD0DD"} width={100} height={100} /></li><li><h4 className="order_num">Step 2</h4><Image className="img_guide" src="/image/desktop/popup/offerings01_02.png" alt={"\uCDA9\uC804\uAE08\uC774 \uC801\uC6A9\uB418\uC5C8\uC5B4\uC694."} width={100} height={100} /></li></ol></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}